import "./DashboardPortfolioSummaryComponentLarge.scss";
import {IComponentOptions, IRootElementService, IScope, ITranscludeFunction} from "angular";
import {MarginQuizService} from "../../../../../quiz/margin/service/MarginQuizService";
import {CurrentUserService} from "../../../../../services/user/CurrentUserService";
import {DashboardPortfolioSummaryComponentController} from "../DashboardPortfolioSummaryComponentController";
import {AccountStore} from "../../../../../account/store/AccountStore";
import {PortfolioService} from "../../../../../portfolio/service/PortfolioService";

export const DashboardPortfolioSummary = "tfDashboardPortfolioSummary";

export function dashboardPortfolioSummary(parentDir: string): IComponentOptions {
    return {
        templateUrl: `${parentDir}/portfolio-summary/large/DashboardPortfolioSummaryComponentLarge.html`,
        transclude: true,
        bindings: {
            model: "<"
        },
        controllerAs: "ctrl",
        controller: DashboardPortfolioSummaryComponentLargeController
    };
}

export class DashboardPortfolioSummaryComponentLargeController extends DashboardPortfolioSummaryComponentController {

    /** @ngInject */
    public constructor($scope: IScope,
                       $element: IRootElementService,
                       private $transclude: ITranscludeFunction,
                       accountStore: AccountStore,
                       portfolioService: PortfolioService,
                       marginQuizService: MarginQuizService,
                       currentUserService: CurrentUserService) {
        super($scope, $element, accountStore, portfolioService, marginQuizService, currentUserService);
    }

    public $onInit(): void {
        super.$onInit();
        this.$transclude((clone) => {
            if (clone != null) {
                this.$element.append(clone);
            }
        });
    }
}
